import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import SentryErrorBoundary from './components/SentryErrorBoundary'
import ProtectedRoute from './components/ProtectedRoute'
import LoginPage from './pages/LoginPage'
import VerifyMagicLinkPage from './pages/VerifyMagicLinkPage'
import DashboardPage from './pages/DashboardPage'
import SettingsPage from './pages/SettingsPage'
import WorkspacesPage from './pages/WorkspacesPage'
import WorkspaceManagementPage from './pages/WorkspaceManagementPage'
import MigrationsPage from './pages/MigrationsPage'
import MigrationDetailPage from './pages/MigrationDetailPage'
import LogoutPage from './pages/LogoutPage'

function App() {
  return (
    <SentryErrorBoundary>
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="/auth/verify" element={<VerifyMagicLinkPage />} />

            {/* Protected routes with organization slug */}
            <Route
              path="/:slug"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/:slug/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/:slug/settings/organizations"
              element={
                <ProtectedRoute>
                  <WorkspacesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/:slug/settings/organizations/:workspaceId"
              element={
                <ProtectedRoute>
                  <WorkspaceManagementPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/:slug/migrations"
              element={
                <ProtectedRoute>
                  <MigrationsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/:slug/migrations/:migrationId"
              element={
                <ProtectedRoute>
                  <MigrationDetailPage />
                </ProtectedRoute>
              }
            />

            {/* Redirect root to active tenancy */}
            <Route path="/" element={<ProtectedRoute redirectToSlug />} />
            <Route path="*" element={<ProtectedRoute redirectToSlug />} />
          </Routes>
        </AuthProvider>
      </Router>
    </SentryErrorBoundary>
  )
}

export default App
